import React, { Fragment } from 'react';
import PropTypes, { object } from 'prop-types';

import {
  Table,
  DateTime,
  TableCell,
  TablePerson,
  Comments
} from 'components/common/Elements/Elements';
import Account from '../Account/Account';

import AdditionalContent from '../AdditionalContent/AdditionalContent';

import classes from './SentimentTable.module.scss';

const TableRow = ({
  company,
  tableConf,
  row,
  mouseEnter,
  onOpenAdditionalModal,
  searchText
}) => {
  return (
    <Table.Row className={classes.row}>
      {tableConf.map(({ title, show, field }, ind) => {
        const cellProps = {
          row: row,
          mouseEnter: mouseEnter,
          ind: ind,
          field: field,
          classes: classes
        };
        return (
          <Fragment key={`${title}-${company._id}}`}>
            {show && field === 'companyName' && (
              <TableCell cellProps={cellProps}>
                <Account data={company} searchText={searchText} />
              </TableCell>
            )}
            {show && field === 'sentimentDate' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.sentimentDate} time />
              </TableCell>
            )}
            {show && field === 'sentiment' && (
              <TableCell cellProps={cellProps} classNameContent={classes.id}>
                {company.sentiment}
              </TableCell>
            )}
            {show && field === 'comments' && (
              <TableCell cellProps={cellProps} classNameContent={classes.id}>
                <Comments
                  title={company.companyName}
                  text={company.comments}
                  data={company}
                  onOpenAdditionalModal={onOpenAdditionalModal}
                  showBtnMorealways
                  onlyNA
                  searchText={searchText}
                  highlighterTrgiger={['sentiment', 'comments']}
                  BodyModal={AdditionalContent}
                />
              </TableCell>
            )}
            {show && field === 'accountManager' && (
              <>
                {company.accountManager !== 'UnAssigned' ? (
                  <TableCell
                    cellProps={cellProps}
                    classNameContent={classes.center}
                  >
                    <TablePerson
                      person={
                        company.accountManager ? company.accountManager : 'NA'
                      }
                    />
                  </TableCell>
                ) : (
                  <TableCell cellProps={cellProps}>
                    {company.accountManager}
                  </TableCell>
                )}
              </>
            )}
          </Fragment>
        );
      })}
    </Table.Row>
  );
};

TableRow.propTypes = {
  company: PropTypes.object,
  tableConf: PropTypes.arrayOf(object),
  row: PropTypes.string,
  mouseEnter: PropTypes.func,
  onOpenAdditionalModal: PropTypes.func.isRequired,
  searchText: PropTypes.string
};

export default TableRow;
